import { render, staticRenderFns } from "./SlotCallback.vue?vue&type=template&id=8f8b4662&scoped=true"
import script from "./SlotCallback.vue?vue&type=script&lang=js"
export * from "./SlotCallback.vue?vue&type=script&lang=js"
import style0 from "./SlotCallback.vue?vue&type=style&index=0&id=8f8b4662&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8b4662",
  null
  
)

export default component.exports